import {useMemo} from 'react';

import {useGetUsersQuery} from '@dms/api/customer';

import {getUserName} from '../utils/getUserName';

export function useGetUserOptions() {
  const {data: users, isLoading} = useGetUsersQuery();

  const userOptions = useMemo(
    () =>
      users
        ?.filter((user) => !user.blocked)
        .map((user) => ({
          label: getUserName(user) ?? '',
          value: user.id,
        })) ?? [],
    [users]
  );

  return {
    userOptions,
    isLoading,
  };
}
